import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { OrderProcessStatus } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { ConverterService } from '../../../../core/util';
import { ORDER_PROCESS_STATUS_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class OrderProcessingConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  getOrderProcessStatus(userId: string, orderCode: string): Observable<OrderProcessStatus> {
    return this.httpClient
      .get<Occ.OrderProcessStatus>(
        this.occEndpointsService.buildUrl('orderProcessStatus', {
          urlParams: {
            userId: userId,
            orderCode: orderCode,
          },
        })
      )
      .pipe(this.converterService.pipeable(ORDER_PROCESS_STATUS_NORMALIZER));
  }
}
